import { Alert, Snackbar } from "@mui/material";
import React from "react";

const CommonSnackbar = ({
  open = false,
  anchorOrigin = { vertical: "top", horizontal: "left" },
  setOpen,
  message = "",
  severity = "success",
}) => {
  const handleClose = (__, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen({
      open: false,
      message: "",
      severity: "error",
    });
  };
  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      autoHideDuration={3000}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CommonSnackbar;
